import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import toastr from "toastr";
import * as authService from '../../services/authService';
import {getCurrentUserId, getJwt} from '../../services/authService';
// import ReactGA from "react-ga";
import $ from 'jquery';

import http from "../../services/httpService";
import DeleteRssModal from '../modals/DeleteRssModal';


import {paginate} from '../../components/utils/paginate_posts'

import {Spinner} from "@blueprintjs/core";
import {Cell, Column, Table,} from "@blueprintjs/table";
import Pagination from '../common/Pagination';
import PostsList from './customPosts/PostsList';
import UpsellModal from "../modals/UpsellModal";
import ContactSupportModal from "../modals/ContactSupportModal";
import sizeMe from 'react-sizeme';
import UpsellModalTailwind from "../modals/UpsellModalTailwind";


const optionsPageSize = [
    {value: 10, text: 10},
    {value: 25, text: 25},
    {value: 50, text: 50},
];

let spinnerComponent = <div style={{marginBottom: 7}}><Spinner size={15}/></div>
let horizontalClickedSpinner = <div
    style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
    <i className="fas fa-envelope-open" style={{color: '#18A9E3'}}></i>
    <div style={{marginLeft: 5}}><Spinner size={15}/></div>
    <div style={{marginLeft: 5}}><Spinner size={15}/></div>
</div>;

class ContentAutomation extends Component {
    state = {
        campaigns: [],
        posts: '',
        totalPosts: '',
        totalPages: '',
        contentCuration: '',
        totalCampaigns: 0,
        total_subscribers: 0,
        push_subscribers: [],
        pageSize: 10,
        currentPage: 1,
        lastPage: false,
        lastPageSize: '',
        paging: '',
        selectedAdAccount: '',
        sortColumn: {
            path: "updated_at",
            order: "asc"
        },
        loader: true,
        selectedCampaignPerformance: 'MESSAGES',
        preview: '',
        forceTableRerender: false,
        rowHeights: [100, 100, 100, 100, 500],
        minTableWidth: 100,
        selectedPlan: '',
        upsellModalVisible: false,
        upgradeModalTitle: '',
        upgradeModalContent: '',
        sources: this.props.sources,
        selectedSource: this.props.selectedSource,
        postsLoader: false,
        fb_page_connected: false,
        facebook_platform_enabled: false,
        webpush_platform_enabled: false,
        viberPlatformEnabled: false,
        deleteRssModalActive: false,
        user: this.props.user,
        platformsEnabled: this.props.platforms_enabled,
        selectedSourceFull: '',
        numberOfSources: '',
        thisSource: this.props.thisSource,
        buttonDisabled: false
    }

    recalculateColsWidth = async () => {
        let tableTotalWidth = 518;
        let containerWidth = this.props.size.width;
        let lastWidth = (containerWidth - tableTotalWidth) > 0 ? (containerWidth - tableTotalWidth) : 150;

        if ((this.state.lastColumnWidth !== lastWidth) && (lastWidth > 0) && containerWidth > 0) {
            await this.setState({lastColumnWidth: lastWidth > 120 ? lastWidth : 120})
            await this.setState({forceTableRerender: true})
            await this.setState({forceTableRerender: false})
        }
    }

    handleFeedInfoMenu = (e) => {
        $(this).toggleClass('opened');
        this.setState({
            feedInfoDotsActive: !this.state.feedInfoDotsActive
        })
        $('.feed-edit .platform-dropdown').fadeToggle();
        if (e.target.id === "feed-edit_edit") {
            const selected_src_info = this.state.data || {};
            this.props.toggleFeedInfo(selected_src_info)
        }
    };

    handleChangeCampaignsNumberPerPage = async (value) => {
        await this.setState({
            currentPage: 1,
            pageSize: value,
            lastPage: value > this.state.totalPosts ? true : this.state.lastPage,
            lastPageSize: value > this.state.totalPosts ? this.state.totalPosts : this.state.lastPageSize,
            loader: true
        })
        await this.getPostsData()
    }

    contentNameCellRenderer = (rowIndex, columnIndex) => {
        const item = this.state.posts[rowIndex];

        return <Cell style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}>
            {
                this.state.loader ?
                    <div>
                        <div className='bp3-skeleton text-skeleton'/>
                    </div>
                    :
                    <p>Active Rss</p>
            }
        </Cell>
    };
    rssLinkCellRenderer = (rowIndex, columnIndex) => {
        const item = this.state.posts[rowIndex];
        return <Cell style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}>
            {
                this.state.loader ?
                    <div>
                        <div className='bp3-skeleton text-skeleton'/>
                        <div className='bp3-skeleton text-skeleton'/>
                    </div>
                    :
                    <p className='multi-line-text-cell f-14'>
                        {this.props.thisSource.rss}
                    </p>
            }
        </Cell>
    };
    autoPushCellRenderer = (rowIndex, columnIndex) => {
        const item = this.state.posts[rowIndex];

        return <Cell style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}>
            {
                this.state.loader ?
                    <div>
                        <div className='bp3-skeleton text-skeleton'
                             style={{width: 78, borderRadius: 5, backgroundColor: '#17AA94', height: 30}}/>
                    </div>
                    :
                    this.props.thisSource.autopush_enabled !== 0 ?
                        <p style={{
                            backgroundColor: '#17AA94',
                            padding: 5,
                            paddingLeft: 10,
                            color: '#fff',
                            borderRadius: 5,
                            width: 78,
                            fontSize: 14
                        }}>Enabled</p>
                        :
                        <p style={{
                            backgroundColor: '$grey-border',
                            padding: 5,
                            paddingLeft: 8,
                            color: '#fff',
                            borderRadius: 5,
                            width: 78,
                            fontSize: 14
                        }}>Disabled</p>
            }
        </Cell>
    };
    editCellRenderer = (rowIndex, columnIndex) => {

        if (this.state.loader) {
            setTimeout(() => this.setState({loader: false}), 2500)
        }
        return <Cell style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}>
            {
                this.state.loader ?
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
                        <div style={{marginRight: 10}}>{spinnerComponent}</div>
                        {spinnerComponent}
                    </div>
                    :
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
                        <div
                            onClick={() => {
                                localStorage.setItem('navigateBackTo', '/content-automation');
                                localStorage.setItem('feed_id', this.props.thisSource.id);
                                localStorage.setItem('removeSuccessMessage', this.props.thisSource.rss ? true : false)
                                this.props.history.push('/rss-feed-source');
                            }}
                            style={{marginRight: 10, cursor: 'pointer'}}>
                            <i className="fas fa-edit"></i>
                        </div>
                        <div
                            id="autopush_edit_remove"
                            title="Rss Feed Remove"
                            // name={selected_src_info.name}
                            // slot={selected_src_info.rss}
                            // onBlur={this.handleFeedInTeam}
                            onClick={(e) => {
                                this.props.openModal(e)
                                this.handleFeedInfoMenu(e)
                            }}
                            style={{cursor: 'pointer', marginTop: 0}}>
                            <i className="fas fa-trash-alt" id="autopush_edit_remove"
                               style={{cursor: 'pointer', marginTop: 0}}></i>
                        </div>
                    </div>
            }
        </Cell>
    };

    contentNameCellRendererLoading = (rowIndex, columnIndex) => {

        return <Cell
            className='campaign-name'
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        >
            <div>
                <div className='bp3-skeleton text-skeleton'/>
            </div>
        </Cell>
    }

    rssCellRendererLoading = (rowIndex, columnIndex) => {

        return <Cell
            className='campaign-name'
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        >
            <div>
                <div className='bp3-skeleton text-skeleton'/>
                <div className='bp3-skeleton text-skeleton'/>
            </div>
        </Cell>
    }

    autoPushCellRendererLoading = (rowIndex, columnIndex) => {

        return <Cell
            className='campaign-name'
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        >
            <div>
                <div className='bp3-skeleton text-skeleton'
                     style={{width: 78, borderRadius: 5, backgroundColor: '#17AA94', height: 30}}/>
            </div>
        </Cell>
    }
    goToPlans = () => {
        this.props.history.push('/subscription-plans')
    }

    handlePageChange = async (page, src = this.state.selected_source) => {

        // console.log("handlePageChange src", src, page);
        if (this.state.selected_source) {
            await this.setState({currentPage: page, postsLoader: true});
            let posts_type = await this.state.selected_source_type || "auto";

            // console.log("handlePageChange src", src, page);
            // await this.props.loadingSourceChange(true);
            try {
                const result = await http.get('api/campaigns/page_size/' + this.state.pageSize + '/feed/' + src + '/' + posts_type + '?page=' + page, {headers: {authorization: getJwt()}});
                // await this.props.loadingSourceChange(false);

                const data = await result.data;
                // console.log("handlePageChange data", data);
                await this.setState({
                    posts: data.posts,
                    total_posts_count: data.total_posts,
                    selected_source_type: 'auto',
                    details: "none",
                    postsLoader: false
                });
            } catch {
                this.setState({postsLoader: false})
                toastr.error('Error with getting posts')
            }

        }
    };

    updateTableWidth = async (index, width) => {
        /* For table width to be rerendered forceRerenderOnSelectionChange in table props should be updated with
         forceTableRerender state change */
        let newTable = this.state.tableColumnsWidth;
        newTable[index] = width;
        await this.setState({
            tableColumnsWidth: newTable,
            forceTableRerender: true
        })
        // this.recalculateColsWidth();
        await this.setState({
            forceTableRerender: false
        })

    }

    componentDidMount = async () => {
        let selectedSourceFull = ''

        let numberOfSources = ''
        if (this.state.user.sources.data.length > 0) {

            selectedSourceFull = await this.state.user.sources.data.filter(
                source => {
                    // //console.log('current source Id : ', source.id)
                    // //console.log('selectedSource id :', this.state.selectedSource);
                    return source.id.toString() === this.state.selectedSource.toString()

                }
            )
        }
        numberOfSources = selectedSourceFull[0].use_custom_plan === 1 && selectedSourceFull[0].custom_plan ?
            selectedSourceFull[0].custom_plan.additional_features.content_automation
            :
            selectedSourceFull[0] && selectedSourceFull[0].plan && selectedSourceFull[0].plan.additional_features ?
                selectedSourceFull[0].plan.additional_features.content_automation : '';
        await this.setState({
            selectedSourceFull,
            numberOfSources,
            selectedPlan: selectedSourceFull[0]?.plan?.plan_id ?? ''
        })
        //ReactGA.pageview(window.location.pathname + window.location.search);
        // const user_id = await getCurrentUserId();
        // const result = await http.get('api/user/' + user_id + '/feed', {headers: {authorization: getJwt()}});
        // const result = await http.get('api/user/' + user_id, {headers: {authorization: getJwt()}});
        const result = await http.get('api/user_info', {headers: {authorization: getJwt()}});
        const userSources = await result.data.data.sources.data;
        //const userFeedsShared = await result.data.data.feeds_shared;
        const selectedFeed = await userSources.find(feed => feed.id.toString() === this.props.selectedSource.toString())
        //const selectedFeedShared = await userFeedsShared.find(feed => feed.project_id.toString() === this.props.selectedSource.toString())
        let platforms_enabled = this.props.platforms_enabled;
        // console.log('platforms_enabled: ', platforms_enabled)
        // console.log('platforms_enabled: ', platforms_enabled)
        let facebook_platform_enabled = platforms_enabled && platforms_enabled.indexOf("fb") > -1;
        let webpush_platform_enabled = platforms_enabled && platforms_enabled.indexOf("wp") > -1;
        let viberPlatformEnabled = platforms_enabled && platforms_enabled.indexOf("vib") > -1;
        await this.setState({
            selectedFeed: selectedFeed || '',
            facebook_platform_enabled,
            webpush_platform_enabled,
            viberPlatformEnabled
        })
        await this.checkFbPageConnected()

        // ReactGA.pageview(window.location.pathname + window.location.search);
        let selectedFilter = localStorage.getItem("posts-filter");


        this.setState({mounted: true});

        this.recalculateColsWidth();
        try {
            // const src = await localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) ? JSON.parse(localStorage.source_clicked) : this.state.selected_source : this.state.selected_source;
            const src = this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) ? JSON.parse(localStorage.source_clicked) : this.state.selected_source : this.state.selected_source;
            if (src) {
                await this.setState({
                    source_clicked: src,
                    postsLoader: true
                });

                const result2 = await http.get('api/campaigns/page_size/' + this.state.pageSize + '/feed/' + src + '/auto', {headers: {authorization: getJwt()}});
                const data = await result2.data;


                await this.setState({
                    loaded: 1,
                    posts: data.posts,
                    total_posts_count: data.total_posts,
                    selected_source_type: 'auto',
                    selected_source: this.props.selectedSource,
                    postsLoader: false
                });


                if (!data) {
                    toastr.error("User id does not match. :(  Please log in again.");
                    this.setState({postsLoader: false})
                    this.props.history.push('/logout');
                }
            } else {
                this.setState({loaded: 2, postsLoader: false});
            }

        } catch (ex) {
            this.setState({mounted: false});
            if (ex.response && ex.response.status === 404)
                toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }
        await this.checkButtonDisabled()

    }
    checkButtonDisabled = async () => {
        //console.log('check button disabled')
        let haveRSS = this.state.thisSource.rss !== null && this.state.thisSource !== ''
        if (this.state.numberOfSources > 1) {
            await this.setState({
                buttonDisabled: haveRSS
            })
        }
    }
    componentDidUpdate = async () => {
        if (this.state.selectedSource !== this.props.selectedSource) {
            const user_id = await getCurrentUserId();
            // const result = await http.get('api/user/' + user_id + '/feed', {headers: {authorization: getJwt()}});
            const result = await http.get('api/user/' + user_id, {headers: {authorization: getJwt()}});
            const userSources = await result.data.data.sources.data;
            //const userFeedsShared = await result.data.data.feeds_shared;
            const selectedFeed = await userSources.find(feed => feed.id.toString() === this.props.selectedSource.toString())
            //const selectedFeedShared = await userFeedsShared.find(feed => feed.project_id.toString() === this.props.selectedSource.toString())
            let selectedSourceFull = ''
            let numberOfSources = ''

            if (this.state.user.sources.data.length > 0) {

                selectedSourceFull = await this.state.user.sources.data.filter(
                    source => {
                        // //console.log('current source Id : ', source.id)
                        // //console.log('selectedSource id :', this.state.selectedSource);
                        return source.id.toString() === this.state.selectedSource.toString()

                    }
                )
            }
            numberOfSources = selectedSourceFull[0]?.plan?.additional_features?.content_automation

            await this.setState({
                selectedFeed: selectedFeed || '',
                selectedSourceFull,
                numberOfSources,
                selectedPlan: selectedSourceFull[0]?.plan?.plan_id,
                buttonDisabled: false
            })
            if ((this.state.selectedFeed && selectedFeed && (this.state.selectedFeed.id.toString() !== selectedFeed.id.toString())) ||
                (!this.state.selectedFeed && selectedFeed) || (this.state.selectedFeed && selectedFeed && (!this.state.selectedFeed.rss !== selectedFeed.rss))) {
                const selectedFeed = await userSources.find(feed => feed.id.toString() === this.props.selectedSource.toString())

                let platforms_enabled = this.props.platforms_enabled;
                //console.log('platforms_enabled: ', platforms_enabled)
                // console.log('platforms_enabled: ', platforms_enabled)
                let facebook_platform_enabled = platforms_enabled && platforms_enabled.indexOf("fb") > -1;
                let webpush_platform_enabled = platforms_enabled && platforms_enabled.indexOf("wp") > -1;
                let viberPlatformEnabled = platforms_enabled && platforms_enabled.indexOf("vib") > -1;
                await this.setState({
                    selectedFeed: selectedFeed || '',
                    facebook_platform_enabled,
                    webpush_platform_enabled,
                    viberPlatformEnabled
                })

                await this.checkFbPageConnected()
            }
            if (this.state.user !== this.props.user) {
                this.setState({user: this.props.user})
            }
            await this.checkButtonDisabled()
        }

        if (this.state.selectedFeed && this.state.selectedFeed.id && (this.state.selectedFeed.id.toString() !== this.props.selectedSource.toString())) {

            await this.setState({selected_source: this.props.selectedSource});
            await this.handlePageChange(1, this.props.selectedSource);

        }

        if (this.state.selected_source && (this.state.selected_source.toString() !== this.props.selectedSource.toString())) {

            this.setState({selected_source: this.props.selectedSource});
            this.handlePageChange(1, this.props.selectedSource);

        }
        if (!this.state.selectedPlan) {
            //console.log('entered componentDidUpdate')
            await this.getSelectedPlan()
        }
        if (this.state.selectedSource !== this.props.selectedSource) {
            let platformsEnabled = this.props.platforms_enabled
            this.setState({
                platformsEnabled,
                selectedSource: this.props.selectedSource
            })
        }
    }

    activateUpsellModal = async (reason) => {
        //console.log('activate modal');
        if (reason === 'unavailable') {
            this.setState({
                upsellModalVisible: true,
                upgradeModalTitle: "Content automation \nisn't available on this plan.",
                upgradeModalContent: 'Choose one of the bigger plans to unlock this feature.'
            })
        } else {
            this.setState({
                upsellModalVisible: true,
                upgradeModalTitle: "You reached the maximum\n of content automation sources for this plan.",
                upgradeModalContent: 'Choose one of the bigger plans to unlock this feature for multiple sources.'
            })
        }
    }

    checkFbPageConnected = async () => {
        if (this.state.fb_page_connected) {
            await this.setState({fb_page_connected: false})
        }
        const {selectedSource} = this.props;
        let facebook_pages = this.props.user.facebook_pages;
        let facebook_pages_shared = this.props.user.facebook_pages_shared;
        // console.log('facebook_pages: ',selectedSource, this.state.fb_page_connected, facebook_pages, facebook_pages_shared, facebook_pages_shared.length, !this.state.fb_page_connected)
        if (facebook_pages && facebook_pages.data && facebook_pages.data.length && !this.state.fb_page_connected) {
            await facebook_pages.data.map(async page => page.feed_id && page.feed_id.toString() === selectedSource.toString() && page.page_connected === 'Connected' ?
                await (this.setState({fb_page_connected: true, selectedSource}))
                : ''
            );
            if (facebook_pages_shared && facebook_pages_shared.length && !this.state.fb_page_connected) {
                await facebook_pages_shared.map(async page => page.project_id && page.project_id.toString() === selectedSource.toString() && page.connected ?
                    await (this.setState({fb_page_connected: true, selectedSource}))
                    : ''
                )
            }
        } else if (facebook_pages_shared && facebook_pages_shared.length && !this.state.fb_page_connected) {
            await facebook_pages_shared.map(async page => page.project_id && page.project_id.toString() === selectedSource.toString() && page.connected ?
                await (this.setState({fb_page_connected: true, selectedSource}))
                : ''
            )
        } else if (this.state.fb_page_connected) {
            this.setState({fb_page_connected: false, selectedSource})
        } else {
            this.setState({selectedSource})
        }
        if (this.state.loader) {
            await this.setState({loader: false})
        }
    }


    getSelectedPlan = async () => {
        //console.log('entered selected plan')
        let user = await this.props.user;
        let projectId = await this.state.selectedSource;
        let project = await user.sources.data.find(project => projectId.toString() === project.id.toString());

        //console.log('getSelectedPlan project: ', project);

        if (project && project.plan) {
            let contentCuration = project.plan.content_curation

            //console.log('content curation: ', contentCuration);
            if (contentCuration) {
                if (contentCuration !== 'Unlimited' && contentCuration !== null) {
                    contentCuration = Number(project.plan.content_curation.substr(0, project.plan.content_curation.indexOf(" ")));

                }

                // console.log('content curation: ', contentCuration);

                await this.setState({contentCuration})
                if (project && project.platforms.length < 1) {
                    await this.props.updateUserFromServer()
                }
                if (project && project.platforms.length > 0) {
                    let smsPlatform = await project.platforms.find(platform => platform.platform === 'sms');
                    let selectedPlan = await smsPlatform ? smsPlatform.plan : '';

                    if (selectedPlan && !this.state.selectedPlan) {
                        await this.setState({selectedPlan})
                    }
                }
            }
        }
    }

    addNewContentSource = () => {
        if (this.state.numberOfSources && this.state.numberOfSources !== 0) {
            if (!this.props.thisSource.rss) {
                localStorage.setItem('feed_id', this.props.selectedSource);
                localStorage.setItem("navigateBackTo", '/content-automation');
                this.props.history.push('/feed-source')
            } else {
                this.activateUpsellModal('limit')
            }
        } else {
            this.activateUpsellModal('unavailable')
        }
    }
    noContentAutomationRenderer = () => {
        return <div className='no-contacts-container panel-container margin-top-20'>
            <img src="/img/emptyStates/tags_content_automation.gif" alt='content-automation'/>
            <h3>There are no RSS links connected to {this.props.selectedSourceName}.</h3>
            <div className='flex-direction-row justify-content-center'>
                {this.state.buttonDisabled ?
                    <button disabled={true} className=' btn-action margin-bottom-10'>
                        Add new content source
                    </button>
                    :
                    <button className=' btn-action margin-bottom-10' onClick={this.addNewContentSource}>
                        Add new content source
                    </button>
                }
            </div>
        </div>
    };

    render() {
        const {
            pageSize, currentPage,
            posts: postsAll, searchQuery, total_posts_count: count, not_implemented,
            sortColumn, selected_source
        } = this.state;
        let details = this.state.details;
        const checked_details = (details === "none");

        let filtered = postsAll;
        if (searchQuery) {
            filtered = this.state.posts.filter(m => m.subscriber_name.toLowerCase().includes(searchQuery.toLowerCase()));
        }
        const currentTodos = paginate(filtered, currentPage, pageSize);
        if (!this.props.selectedSource) {
            return <React.Fragment>
                <div className="display-flex">
                    <h1 className='main-title'>Content Automation</h1>
                </div>
                <div className="row">
                    <div className="col-xs-12 text-center no-feeds-containers">
                        <div className="feed-msg">
                            <img className='emitto-mark' src="/img/emitto-mark.png" alt="Emitto Mark"/>
                            <p className="text-center ">{authService.getCurrentUserName()}</p>
                            <p>It looks like you haven't set up any workspaces yet. Add your first workspace, and
                                start
                                growing
                                your audience.</p>
                            <img className='cat-img' src="/img/cat-transparent.gif" alt="No Workspaces"/>
                        </div>
                        <Link to='/workspace-name'>
                            <button className='btn-action btn-m' type="button">
                                Create your first workspace
                            </button>
                        </Link>
                    </div>
                </div>
            </React.Fragment>
        }
        let thisSource = this.props.thisSource;
        return (
            <React.Fragment>
                <h1 className='main-title'>Content Automation</h1>
                <div className="d-block" style={{marginBottom: 20}}>
                    {/*{ this.state.preview ? <div dangerouslySetInnerHTML={{ __html: this.state.preview }} /> : null }*/}
                    <div>
                        <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                            {/*{console.log('there is no source')}*/}
                            <div>
                                {this.state.buttonDisabled ?
                                    <button disabled={true} className=' btn-action margin-bottom-10'>
                                        Add new content source
                                    </button>
                                    :
                                    <button className=' btn-action margin-bottom-10' onClick={this.addNewContentSource}>
                                        Add new content source
                                    </button>
                                }
                            </div>
                        </div>

                    </div>
                    {this.state.numberOfSources && this.state.numberOfSources !== 0 ?
                        thisSource.rss ?
                            <div className='content-automation-table-container'>
                                <div className='row-container'>
                                    <div className='column-container small'>
                                        <p className='label'>Content Name</p>
                                        <div className="value-container">
                                            {
                                                this.state.loader ?
                                                    <div>
                                                        <div className='bp3-skeleton text-skeleton'
                                                             style={{
                                                                 width: 78,
                                                                 borderRadius: 5,
                                                                 backgroundColor: '#17AA94'
                                                             }}/>
                                                    </div>
                                                    :
                                                    <p>Active Rss</p>
                                            }
                                        </div>
                                    </div>
                                    <div className='column-container medium'>
                                        <p className='label'>RSS Link</p>
                                        <div className='value-container'>
                                            {
                                                this.state.loader ?
                                                    <div>
                                                        <div className='bp3-skeleton text-skeleton'
                                                             style={{
                                                                 width: '80%',
                                                                 borderRadius: 5,
                                                                 backgroundColor: '#17AA94'
                                                             }}/>
                                                    </div>
                                                    :
                                                    <p className='multi-line-text-cell f-14'>{this.props.thisSource.rss}</p>
                                            }
                                        </div>
                                    </div>
                                    <div className='column-container large'>
                                        <p className='label'>Autopush</p>
                                        <div className='value-container'>
                                            {
                                                this.state.loader ?
                                                    <div>
                                                        <div className='bp3-skeleton text-skeleton'
                                                             style={{
                                                                 width: 78,
                                                                 borderRadius: 5,
                                                                 backgroundColor: '#17AA94',
                                                                 height: 30
                                                             }}/>
                                                    </div>
                                                    :
                                                    this.props.thisSource.autopush_enabled ?
                                                        <p style={{
                                                            backgroundColor: '#17AA94',
                                                            padding: 5,
                                                            paddingLeft: 10,
                                                            color: '#fff',
                                                            borderRadius: 5,
                                                            width: 78,
                                                            fontSize: 14
                                                        }}>Enabled</p>
                                                        :
                                                        <p className='f-14'>Disabled</p>
                                            }
                                        </div>
                                    </div>
                                    <div className='column-container small'>
                                        <p className='label'></p>
                                        <div className='value-container'>
                                            {
                                                this.state.loader ?
                                                    <div className="edit-container">
                                                        <div style={{marginRight: 10}}>{spinnerComponent}</div>
                                                        {spinnerComponent}
                                                    </div>
                                                    :
                                                    <div className='edit-container'>
                                                        <div onClick={() => {
                                                            localStorage.setItem('navigateBackTo', '/content-automation');
                                                            localStorage.setItem('feed_id', this.props.thisSource.id);
                                                            localStorage.setItem('removeSuccessMessage', this.props.thisSource.rss ? true : false)
                                                            this.props.history.push('/rss-feed-source');
                                                        }}
                                                             style={{marginRight: 10, cursor: 'pointer'}}>
                                                            <i className="fas fa-edit"></i>
                                                        </div>
                                                        <div
                                                            id="autopush_edit_remove"
                                                            title="Rss Feed Remove"
                                                            // name={selected_src_info.name}
                                                            // slot={selected_src_info.rss}
                                                            // onBlur={this.handleFeedInTeam}
                                                            onClick={(e) => this.setState({
                                                                deleteRssModalActive: true
                                                            })}
                                                            style={{cursor: 'pointer', marginTop: 0}}>
                                                            <i className="fas fa-trash-alt"
                                                               id="autopush_edit_remove"
                                                               style={{cursor: 'pointer', marginTop: 0}}></i>
                                                        </div>
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            this.noContentAutomationRenderer()
                        :
                        <div className='no-contacts-container panel-container margin-top-20'>
                            <h2>Content Automation isn't available on this plan</h2>
                            <p>Please upgrade to bigger plan to unlock this feature.</p>
                            <button className=' btn-action margin-bottom-10'
                                    onClick={() => this.activateUpsellModal('unavailable')}
                            >
                                Go to plans
                            </button>

                        </div>
                    }
                </div>
                {/*{ console.log(this.state.selectedFeed || 'Nema', this.props.thisSource, currentTodos, this.props.loadingSource, this.state.filterLoader, this.state.loaded)}*/}
                {this.state.postsLoader ?
                    <div className='full-screen-loader'>
                        <img src="/img/chart-loader.svg" alt="Loading..."/>
                    </div>
                    :
                    thisSource && thisSource.rss ?
                        <React.Fragment>
                            {this.state.posts && this.state.posts.length > 0 ?
                                <PostsList
                                    fb_page_connected={this.state.fb_page_connected}
                                    facebook_platform_enabled={this.state.facebook_platform_enabled}
                                    webpush_platform_enabled={this.state.webpush_platform_enabled}
                                    viberPlatformEnabled={this.state.viberPlatformEnabled}
                                    thisSource={this.props.thisSource}
                                    posts={this.state.posts} detailsGlobal={details}
                                    history={this.props.history}
                                    platformsEnabled={this.state.platformsEnabled}
                                    user={this.state.user}
                                />
                                :
                                <div style={{height: 800}}/>
                            }
                        </React.Fragment>
                        :
                        ''
                }

                {thisSource && thisSource.rss && this.state.posts.length > 0 ?
                    <Pagination
                        itemsCount={count}
                        pageSize={pageSize}
                        currentPage={currentPage}
                        onPageChange={this.handlePageChange}/>
                    :
                    ''
                }
                <DeleteRssModal
                    showModal={this.state.deleteRssModalActive}
                    handleClose={() => this.setState({deleteRssModalActive: false})}
                    selectedSource={this.props.selected_source}
                    maxWidth={600}
                    history={this.props.history}
                    user={this.props.user}
                    updateUserFromServer={this.props.updateUserFromServer}
                    thisSource={thisSource}
                />
                <UpsellModalTailwind


                    selectedSource={this.state.selectedSource}
                    showModal={this.state.upsellModalVisible}
                    handleClose={() => this.setState({upsellModalVisible: false})}
                    maxWidth={null}
                    history={this.props.history}
                    title={this.state.upgradeModalTitle}
                    content={this.state.upgradeModalContent}

                    plan={this.state.selectedPlan}
                    user={this.props.user}
                    selectedSource={this.state.selectedSource}
                />
                <ContactSupportModal
                    name={this.props.name}
                    email={this.props.email}
                    visible_modal={this.props.visible_modal}
                    onClickAway={this.props.closeModal}
                    acceptModal={this.props.acceptModal}
                    team_name=""
                />
            </React.Fragment>
        )
    }

}

export default sizeMe()

(ContentAutomation);

